import type { ConstanciaSegment } from './constanciaPdfTemplate';

/**
 * Agrupa el historial completo de sesiones de un/a paciente por profesional,
 * para armar los tramos de la Constancia. Portal-agnóstico: reutilizable desde
 * cualquier origen de datos (hoy psi-platform, a futuro el portal de pacientes).
 */
export interface ConstanciaSourceSession {
  process_id: string;
  status: string;
  date: string;
  psychologist_id?: string | null;
  psychologist_name: string;
}

/**
 * Filtra únicamente sesiones "settled" y las agrupa por profesional, unificando
 * el período y el conteo cuando la misma profesional tuvo más de un proceso.
 * Devuelve los tramos ordenados cronológicamente por inicio de período.
 */
export function buildConstanciaSegments(sessions: ConstanciaSourceSession[]): ConstanciaSegment[] {
  const settled = sessions.filter((s) => s.status === 'settled');
  const byProfessional = new Map<string, { name: string; count: number; from: string; to: string }>();

  for (const s of settled) {
    const key = s.psychologist_id || s.psychologist_name;
    const existing = byProfessional.get(key);
    if (!existing) {
      byProfessional.set(key, { name: s.psychologist_name, count: 1, from: s.date, to: s.date });
    } else {
      existing.count += 1;
      if (s.date < existing.from) existing.from = s.date;
      if (s.date > existing.to) existing.to = s.date;
    }
  }

  return Array.from(byProfessional.values())
    .sort((a, b) => a.from.localeCompare(b.from))
    .map((v) => ({ psychologistName: v.name, sessionCount: v.count, periodFrom: v.from, periodTo: v.to }));
}
